export function formatCompactDuration(ms: number): string {
  if (ms < 1000) return "<1s";
  const totalSeconds = Math.floor(ms / 1000);
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const totalMinutes = Math.floor(totalSeconds / 60);
  if (totalMinutes < 60) {
    const s = totalSeconds % 60;
    return s === 0 ? `${totalMinutes}m` : `${totalMinutes}m ${s}s`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return m === 0 ? `${hours}h` : `${hours}h ${m}m`;
}
